"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgBack(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "6 0 14 24", fill: "none" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.03 12l5.07 5 1.448-1.429-2.595-2.561h8.367v-2.02h-8.367l2.595-2.561L12.1 7l-5.07 5z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Back')(SvgBack);
//# sourceMappingURL=Back.js.map